import { LeadStatus, DraftStatus } from "../lib/types";
import { LEAD_STATUS_CONFIG, DRAFT_STATUS_CONFIG } from "../lib/leadStatus";

export function LeadStatusPill({ status }: { status: LeadStatus | string }) {
  const cfg = LEAD_STATUS_CONFIG[status as LeadStatus];
  if (!cfg) {
    return (
      <span className="inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium bg-status-cold/10 text-status-cold ring-1 ring-status-cold/20">
        {status}
      </span>
    );
  }
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium ${cfg.classes}`}
    >
      {cfg.emoji && <span className="text-[10px]">{cfg.emoji}</span>}
      {cfg.label}
    </span>
  );
}

export function DraftStatusPill({ status }: { status: DraftStatus | string }) {
  const cfg = DRAFT_STATUS_CONFIG[status as DraftStatus];
  if (!cfg) return null;
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium ${cfg.classes}`}
    >
      {cfg.emoji && <span className="text-[10px]">{cfg.emoji}</span>}
      {cfg.label}
    </span>
  );
}

export function EyebrowPill({ children }: { children: React.ReactNode }) {
  return (
    <span className="inline-flex items-center rounded-full bg-accent-tint px-2.5 py-1 text-[10px] font-semibold uppercase tracking-wider text-accent-400 ring-1 ring-accent-500/20">
      {children}
    </span>
  );
}
